import React, { SVGProps } from 'react'
export const ThirdDefaultLeftSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M6.409 6.955C3.429 9.543.837 13.566 1 19.99c.169 6.658 3.588 10.51 6.91 12.715C11.264 34.929 14.07 35 16 35v1c-2.07 0-5.085-.102-8.642-2.462C3.772 31.158.178 27.01 0 20.015-.17 13.333 2.52 9.01 5.753 6.2 8.962 3.412 12.237 2.68 16 2.02v1c-3.7.649-6.587 1.325-9.591 3.935Z"
      clipRule="evenodd"
    />
  </svg>
)
